<div class="claude-connect">
    <div class="claude-connect__card">
        <h1>Claude koppelen aan Resumo</h1>

        <p *ngIf="state() === 'loading'">Even laden…</p>

        <ng-container *ngIf="state() === 'expired'">
            <p data-testid="claude-connect-expired">{{ error() || 'Deze koppelaanvraag is verlopen of al gebruikt. Start het koppelen opnieuw vanuit Claude.' }}</p>
        </ng-container>

        <ng-container *ngIf="request() as req">
            <ng-container *ngIf="state() === 'ready' || state() === 'busy'">
                <p>
                    <strong>{{ req.clientName }}</strong> ({{ req.redirectHost }}) vraagt toegang tot Resumo als
                    <strong data-testid="claude-connect-user">{{ req.userEmail }}</strong>.
                </p>
                <p>Claude kan dan, met jouw rechten in Resumo:</p>
                <ul>
                    <li>projecten, partners, contactpersonen, medewerkers, CRM-deals en timesheets lezen;</li>
                    <li>projecten, partners, contactpersonen en CRM-deals aanmaken of wijzigen;</li>
                    <li>timesheets aanmaken en uren registreren.</li>
                </ul>
                <p class="form-helptext">Claude kan niets verwijderen. Je kan de koppeling altijd intrekken onder Settings → Claude.</p>

                <div class="claude-connect__actions">
                    <button class="button" type="button" data-testid="claude-connect-approve" [disabled]="state() === 'busy'" (click)="approve()">
                        Toestaan
                    </button>
                    <button class="button button--outline" type="button" data-testid="claude-connect-deny" [disabled]="state() === 'busy'" (click)="deny()">
                        Weigeren
                    </button>
                </div>
            </ng-container>
        </ng-container>

        <p *ngIf="state() === 'redirecting'">Je wordt teruggestuurd naar Claude…</p>
    </div>
</div>
